<template>
  <div>
    <HeaderTabs
      :tabs-list="administrationTabs"
    />
    <SpinnerContainer
      v-if="appLoading"
      :is-loading="appLoading"
      class="nested-tab-page-spinner"
    />
    <router-view />
  </div>
</template>

<script>
  import HeaderTabs from 'components/common/HeaderTabs/HeaderTabs';
  import translation from 'translation';
  import {SpinnerContainer} from '@marilyn/marilyn-ui';
  import {mapGetters} from 'vuex';

  export default {
    name: 'UserSettingsNestedPage',
    components: {HeaderTabs, SpinnerContainer},
    computed: {
      ...mapGetters('common', ['appLoading']),
      administrationTabs () {
        return [
          {
            id: 'info',
            title: translation.tr('Information'),
            to: {name: 'userInfo'},
            exactMatch: true
          },
          {
            id: 'settings',
            title: translation.tr('Settings'),
            to: {name: 'userSettings'}
          },
          {
            id: 'sessions',
            title: translation.tr('Sessions'),
            to: {name: 'userSessions'}
          }
        ];
      }
    }
  };
</script>
